import { useMemo } from 'react'
import { useWindowSize } from 'usehooks-ts'

const useDeviceDetect = () => {
  const { width: windowWidth } = useWindowSize()

  const userAgent = useMemo(() => (typeof window.navigator === 'undefined' ? '' : navigator.userAgent), [])

  const isMobile = useMemo(
    () => !!(userAgent.match(/Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i) || windowWidth < 840),
    [userAgent, windowWidth],
  )
  const isTablet = useMemo(() => windowWidth < 1024, [windowWidth])
  const isDesktop = useMemo(
    () => !!((!isMobile && !userAgent.match(/SSR/i)) || windowWidth >= 840),
    [isMobile, userAgent, windowWidth],
  )

  return { isDesktop, isTablet, isMobile }
}

export default useDeviceDetect
